import { forwardRef, memo, useCallback, useState } from "react";
import { number } from "card-validator";
import classNames from "classnames";
import { Input, InputProps } from "../../Input";

import styles from "./style.module.scss";

const defaultCardType = "unknown";
const defaultCardMaxLength = 19;
const defaultGaps = [ 4, 8, 12 ];

export type CardNumberFieldProps = Omit<InputProps, "onChange" | "value"> & {
  onChange?: (value: string) => void,
  value?: string,
  maxLength?: number
}

export const CardNumberField = memo<CardNumberFieldProps>(forwardRef<any, CardNumberFieldProps>((
  {
    onChange,
    value,
    maxLength,
    ...props
  }, ref) => {

  const [ cardType, setCardType ] = useState<string>(defaultCardType);
  const [ gaps, setGaps ] = useState<number[]>(defaultGaps);
  const [ cardMaxLength, setCardMaxLength ] = useState<number>(defaultCardMaxLength);

  const wrappedOnChange = useCallback((e: any) => {
    const newValue = (e?.target?.value || "").replace(/\D/g, "");
    const cardNumberVerification = number(newValue);
    if (cardNumberVerification.isPotentiallyValid) {
      setCardType(cardNumberVerification.card?.type || defaultCardType);
      setGaps(cardNumberVerification?.card?.gaps || defaultGaps);
      setCardMaxLength(
        Math.max(...cardNumberVerification.card?.lengths || [ defaultCardMaxLength ]) +
        (cardNumberVerification.card?.gaps?.length || 0),
      );
    } else {
      setCardType(defaultCardType);
      setGaps(defaultGaps);
      setCardMaxLength(defaultCardMaxLength);
    }
    onChange?.(newValue);
  }, [ onChange ]);

  const formattedValue = (value || "")
    .split("")
    .map((x, i) => gaps.includes(i + 1) ? `${x} ` : x)
    .join("")
    .trimEnd();

  return <Input
    autoComplete="cc-number"
    autoCorrect="off"
    spellCheck="false"
    inputMode="numeric"
    maxLength={cardMaxLength}
    {...props}
    value={formattedValue}
    ref={ref}
    type="text"
    onChange={wrappedOnChange}>
    <span className={classNames(styles.logo, styles[cardType])} />
  </Input>;
}));

export default CardNumberField;
